import { stringToColor } from '@components/storeMap/categoryGrouping/shelfGrouping'
import { isProdMode } from '@utils/env'

import Shelf, { type ShelfProps } from './Shelf'

function CategoryShelf({ shelf, ...props }: ShelfProps) {
  if (isProdMode) return null

  // Generate a deterministic color based on the shelf category
  const fill = shelf.statistics?.shelfCategory
    ? stringToColor(shelf.statistics.shelfCategory)
    : undefined

  return <Shelf shelf={shelf} fill={fill} {...props} />
}

export default CategoryShelf